import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../helpers/Colors";
import { fontSize } from "../../helpers/fontSize";
import axios from "axios";
import Table_myReservations from "./section/Table_myReservations";
import { ax_myReservations } from "../../api/reservation";

const useStyles = makeStyles({
  Reservation: {
    backgroundColor: Colors.primaryExtraLight2,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-Width: 770px) ": {
      padding: "5px 10px",
    },
    // // --------ipad
    "@media (min-width: 770px) and (max-width: 1025px)": {
      padding: "10px 25px",
    },
    // --------desktop
    "@media (min-width: 1025px) and (max-Width: 2560px) ": {
      padding: "10px 25px",
    },
  },
  Content: {
    overflow: "auto",
    width: "100%",
    height: "100%",
    backgroundColor: Colors.primaryExtraLight2,
    "& .heading": {
      padding: "0px 0px 15px 0",
      fontSize: fontSize.heading,
      fontWeight: 500,
      // --------- from xs(380px) till md(770px)
      "@media only screen and (max-Width: 770px)": {
        fontSize: fontSize.question,
      },
      "@media only screen and (max-Width: 900px)": {
        padding: "0px 0px 0px 0",
      },
    },
    "& .subHeading": {
      padding: "10px 25px",
      fontSize: fontSize.question,
      fontWeight: 400,
    },
    "& .Overall_Date_Con": {
      // backgroundColor: Colors.success,
      // padding: "0px 25px",
      // fontSize: fontSize.heading,
      // fontWeight: 500,
    },
    "& .Overall_Time_Con": {
      // backgroundColor: Colors.grey,
    },
  },
});

const MyReservations = ({ user, triggerUseEffect, setUseEffect }) => {
  const classes = useStyles();
  const [myReservations, setMyReservations] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const items = [
    {
      fName: "Akbar",
      lName: "sha",
      userName: "zIndex",
      path: "/akbar",
    },
    {
      fName: "Asen",
      lName: "Ali",
      userName: "asen",
      path: "/asen",
    },
    {
      fName: "Ashik",
      lName: "bhai",
      userName: "dev",
      path: "/ashik",
    },
  ];

  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const email = user.email;
        const ax = await ax_myReservations(email);
        console.log("ax:- " + JSON.stringify(ax));
        if (ax.code === 200) {
          setMyReservations(ax.data);
          setUseEffect(true);
        }
      } catch (e) {
        console.log("Error while fetching my reservations:- " + e);
      }
    };
    ax_fetch();
  }, [triggerUseEffect, showEditModal]);
  // console.log("my reser:- " + myReservations);

  return (
    <main
      className={`${classes.Reservation}`}
      style={{ height: "calc(100vh - 58px)" }}
    >
      <section
        // className={`${classes.Content} max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
        className={`${classes.Content} `}
        // max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6
      >
        <section className="p-2 900px:px-0 900px:py-2 flex items-center justify-between">
          <div className="heading">
            My Reservations - ({myReservations.length})
          </div>
          {/* <div className="subHeading">
            Total Reservations - <span className="text-secondary"></span>
          </div> */}
        </section>

        <div className="Overall_Date_Con ">
          <Table_myReservations
            myReservations={myReservations}
            showEditModal={showEditModal}
            setShowEditModal={setShowEditModal}
            showCancelModal={showCancelModal}
            setShowCancelModal={setShowCancelModal}
            triggerUseEffect={triggerUseEffect}
            setUseEffect={setUseEffect}
          />
        </div>
        <div>{/* <Test items={items} /> */}</div>
      </section>
    </main>
  );
};

export default MyReservations;
